import React from 'react';
import './NotFound.css';

const NotFound = () => (
  <div className="ap-page nf-page">
    <span className="ap-overline">Erro 404</span>
    <p className="nf-code ap-num" aria-hidden="true">404</p>
    <h1 className="ap-headline">Link não encontrado</h1>
    <p className="nf-text">O link que você acessou não existe ou foi removido.</p>
    <a href="/" className="nf-link">Voltar para o início</a>
  </div>
);

export default NotFound;
